import { render } from "./SongEditorPart.vue?vue&type=template&id=55a9b012&scoped=true"
import script from "./SongEditorPart.vue?vue&type=script&lang=js"
export * from "./SongEditorPart.vue?vue&type=script&lang=js"

import "./SongEditorPart.vue?vue&type=style&index=0&id=55a9b012&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55a9b012"

export default script